
const initState = {
    marketplaceSelectedCourse: 'close',
    courseWarning: 'none',
    lectureWarning: 'none',

};

const toggleEditContentReducer = (state=initState, action) => {
    
    switch (action.type) {

        case 'EDIT_COURSE':

            return {
                ...state,
                ToggleEditContent: action.ToggleEditContent,
                courseWarning: action.courseWarning,
                lectureWarning: action.lectureWarning,
            }

        default:

            return state;
           
    }

}


export default toggleEditContentReducer